import React from 'react';

import { ColorTokenProp, ColorToken } from '../../../theme/tokens/color';
import { ButtonColorToken } from '../../../theme/tokens/button-color';
import { mapTokenProp } from '../../../theme/tokens/utils';

import { PhoneNumberWrapper } from '../../CtaWidget/LegacyPhoneNumberWidget/PhoneNumberWidget.styles';

import { DEFAULT_BUTTON_TEXT } from '../../CtaWidget/LegacyPhoneNumberWidget';
import {
  ctaWidgetEnum,
  DEFAULT_LABEL_V1,
  DEFAULT_PLACEHOLDER_V1
} from '../../CtaWidget/shared';
import { NodeProps } from './shared';

import { LinkButton } from '../../Button';
import { Flexbox } from '../../Flexbox';
import { Box } from '../../Box';
import { Text } from '../../Text';
import { ImageWith7030TextEmbed } from '../../ImageWith7030Text/ImageWith7030TextEmbed';
import CtaWidget from '../../CtaWidget';

interface EmbeddedEntryNodeProps extends NodeProps {
  colour: ColorTokenProp;
}

export function EmbeddedEntryNode({ node, colour }: EmbeddedEntryNodeProps) {
  const {
    fields: {
      text,
      url,
      icon,
      buttonBackgroundColor,
      buttonHoverBackgroundColor,
      forwardedButtonParams
    },
    sys
  } = node.data?.target ?? {};

  switch (sys?.contentType?.sys?.id) {
    case 'button':
      const { file, description } = icon?.fields ?? {};
      const iconSrc = file?.url ? `https:${file?.url}` : undefined;
      const iconAlt = description ?? undefined;

      return (
        <LinkButton
          href={url}
          buttonColor={mapTokenProp<ColorToken, ButtonColorToken>(colour, (c) =>
            c === 'white' ? 'light' : 'dark'
          )}
          buttonHoverColor={mapTokenProp<ColorToken, ButtonColorToken>(
            colour,
            (c) => (c === 'white' ? 'lightHover' : 'darkHover')
          )}
          attachParams={forwardedButtonParams !== undefined}
          forwardedButtonParams={forwardedButtonParams}
        >
          <Flexbox alignItems="center" justifyContent="space-around">
            {text}
            {iconSrc && (
              <Box
                marginLeft="sm"
                marginRight="s"
                style={{ position: 'relative' }}
              >
                <img src={iconSrc} alt={iconAlt} loading="lazy" />
              </Box>
            )}
          </Flexbox>
        </LinkButton>
      );

    case 'disclaimer':
      return (
        <Text
          as="p"
          fontSize={{
            0: 'small_p_0',
            desktop: 'small_p_tablet'
          }}
          colour={colour}
        >
          {text}
        </Text>
      );

    case 'imageWith7030Text':
      return <ImageWith7030TextEmbed {...node?.data?.target?.fields} />;

    case 'phoneNumberField':
      return (
        <PhoneNumberWrapper>
          <CtaWidget
            id={`phone-number-widget-${sys.id}`}
            module="Rich Text"
            errorPosition="bottom"
            width="100%"
            sysId="nonContentfulCta"
            designType={ctaWidgetEnum.INBLOCK_PHONE_NUMBER_V1}
            placeholderText={DEFAULT_PLACEHOLDER_V1}
            labelText={DEFAULT_LABEL_V1}
            cfButtonColor={buttonBackgroundColor || 'green'}
            cfButtonHoverColor={buttonHoverBackgroundColor || 'sweetmint'}
            buttonContent={DEFAULT_BUTTON_TEXT}
          />
        </PhoneNumberWrapper>
      );
    default:
      return null;
  }
}
